import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import HomePage from './pages/home-page';
import GalleryPage from './pages/GalleryPage.tsx';
//import GalleryPage from './pages/gallery-page';
// import CharityPage from './pages/charity-page';
import TermsPage from './pages/terms-and-conditions';
import EventsPage from '../src/pages/events.tsx';
import CharitiesPage from './pages/CharitiesPage';


function App() {
  return (
    <>
    <Router>
      <NavBar />
      <div className="page-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage/>}/>
          <Route path="/charities" element={<CharitiesPage/>} />
          <Route path="/terms" element={<TermsPage/>} />
          <Route path='/events' element={<EventsPage/>}/>
          {/* <Route path="/events" element={<EventsPage />} />  new route */}
        </Routes>
      </div>
    </Router>
    </>
  );
}

export default App;
